export enum ActionType {
    Action = "Action",
    ActionLink = "ActionLink",
    ActionGroup = "Action Group",
    //JGU
    TOULink = "TOU-Link",
    UMSLink = "UMS-Link",
    
    //Portal - Redirect
    PortalLink = "Portal-Link",
    HyperLink = "Hyper-Link"
}